import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ReviewList from './components/ReviewList';
import AdminPage from './components/AdminPage';
import ReviewDetailModal from './components/ReviewDetailModal';
import api from './services/api';

function App() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedReview, setSelectedReview] = useState(null);
  const [filters, setFilters] = useState({
    search: '',
    type: '',
    tags: '',
    sort: 'created_at',
    order: 'DESC'
  });

  useEffect(() => {
    fetchReviews();
  }, [filters]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchReviews = async () => {
    try {
      setLoading(true);
      setError(null);
      console.log('🔄 Fetching reviews...');
      
      const data = await api.getReviews(filters);
      console.log('✅ Reviews fetched:', data);
      
      setReviews(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error('❌ Error fetching reviews:', err);
      setError(`API fejl: ${err.message}`);
      setReviews([]); // Fallback to empty array
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (newFilters) => {
    setFilters(prev => ({ ...prev, ...newFilters }));
  };

  const handleReviewClick = (review) => {
    setSelectedReview(review);
  };

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={
            <>
              <Header />
              <main>
                <div className="container">
                  {error && (
                    <div style={{ 
                      padding: '20px', 
                      textAlign: 'center', 
                      background: 'rgba(255, 107, 107, 0.1)', 
                      borderRadius: '20px',
                      color: '#ff6b6b',
                      marginBottom: '20px',
                      border: '1px solid rgba(255, 107, 107, 0.3)'
                    }}>
                      <p>⚠️ {error}</p>
                      <p style={{ fontSize: '14px', marginTop: '10px' }}>
                        Tjek browser console for detaljer (F12)
                      </p>
                    </div>
                  )}
                  
                  <ReviewList
                    reviews={reviews}
                    loading={loading}
                    filters={filters}
                    onFilterChange={handleFilterChange}
                    onReviewClick={handleReviewClick}
                  />
                </div>
              </main>
              <Footer />
            </>
          } />
          
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
        
        {/* Review Detail Modal */}
        {selectedReview && (
          <ReviewDetailModal
            review={selectedReview}
            onClose={() => setSelectedReview(null)}
          />
        )}
      </div>
    </Router>
  );
}

export default App;
